// 云校APP在公众号的下载页

<template>
  <div class="page">
    <div class="wrap">
      <div class="logo"></div>
      <div class="btn" @click="down"></div>
      <div class="bottomImg"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageTitle: '校管家云校',
      channelType: this.$route.query.channelType || 'none',
      androidApkUrl: '',
    };
  },
  methods: {
    sendStatistics(eventType = 1) {
      this.$api.addChannelStatistics({
        pageId: '3',
        pageName: '云校APP下载落地页',
        channelType: this.channelType,
        eventType: eventType,
      });
    },
    down() {
      if (app.base.env == 'wx') {
        // 在路由切换时, 隐藏微信菜单中的非基础功能按钮
        app.sdk.triggerMenu(true);
        app.x3.popup.browerOpen();
      } else {
        if (app.base.isIos) {
          this.sendStatistics(3);
          //苹果跳下载链接
          window.open('https://itunes.apple.com/cn/app/id1571838977');
        } else {
          this.sendStatistics(2);
          //安卓跳下载链接
          window.location.href = this.androidApkUrl;
        }
      }
    },
    // 获取不同渠道下的APK包
    async getApk() {
      let ret = await axios({
        url: 'https://xgj-files.oss-cn-hangzhou.aliyuncs.com/uploads/mobile/app-yunxiao/apk/conf.json',
      });

      console.log(ret);
      this.androidApkUrl = ret.data[this.channelType] || ret.data['main'];
    },
  },
  created() {
    this.sendStatistics(1);
    this.getApk();
  },
};
</script>

<style lang="scss" scoped>
.page {
  margin: 0 auto;
  max-width: 600px;
  font-size: 0;
  background: linear-gradient(180deg, #00b2ff 0%, #00acff 100%);
  box-shadow: 0px 9px 8px -8px rgba(0, 173, 255, 0.5);
  .wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/simple/h5/page3/01.png);
    background-size: 100% auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .logo {
      margin-top: 20%;
      width: 151px;
      height: 155px;
      background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/simple/h5/page3/02.png);
      background-size: cover;
      background-position: center;
    }
    .btn {
      margin-top: 14%;
      width: 215px;
      height: 54px;
      background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/simple/h5/page3/04.png);
      background-size: cover;
      background-position: center;
    }
    .bottomImg {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 211px;
      height: 172px;
      background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/simple/h5/page3/03.png);
      background-size: cover;
      background-position: center;
    }
  }
}
</style>